import React from 'react';
import { theme } from 'antd';

const { useToken } = theme;

const FlowIconOutlined = ({ color }: { color?: string }) => {
  const { token } = useToken();
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
      <g clipPath="url(#clip0_567_18733)">
        <path
          d="M6.88649 11.949C7.51942 11.3161 7.875 10.4576 7.875 9.5625H1.125C1.125 10.4576 1.48058 11.3161 2.11351 11.949C2.74645 12.5819 3.60489 12.9375 4.5 12.9375C5.39511 12.9375 6.25355 12.5819 6.88649 11.949Z"
          stroke={color ?? token.colorPrimary}
          strokeWidth="1.24"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.949 11.1135C11.3161 10.4806 10.4576 10.125 9.5625 10.125V16.875C10.4576 16.875 11.3161 16.5194 11.949 15.8865C12.5819 15.2536 12.9375 14.3951 12.9375 13.5C12.9375 12.6049 12.5819 11.7464 11.949 11.1135Z"
          stroke={color ?? token.colorPrimary}
          strokeWidth="1.24"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.1135 6.05101C10.4806 6.68395 10.125 7.54239 10.125 8.4375H16.875C16.875 7.54239 16.5194 6.68395 15.8865 6.05101C15.2536 5.41808 14.3951 5.0625 13.5 5.0625C12.6049 5.0625 11.7464 5.41808 11.1135 6.05101Z"
          stroke={color ?? token.colorPrimary}
          strokeWidth="1.24"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.05101 6.88649C6.68395 7.51942 7.54239 7.875 8.4375 7.875L8.4375 1.125C7.54239 1.125 6.68395 1.48058 6.05101 2.11351C5.41808 2.74645 5.0625 3.60489 5.0625 4.5C5.0625 5.39511 5.41808 6.25355 6.05101 6.88649Z"
          stroke={color ?? token.colorPrimary}
          strokeWidth="1.24"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_567_18733">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default FlowIconOutlined;
